module.exports = __webpack_public_path__ + "img/list2.5a258341.png";